/*
  Copyright (C) 2022 by USHIN, Inc.

  This file is part of U4U.

  U4U is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  U4U is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with U4U.  If not, see <https://www.gnu.org/licenses/>.
*/
import React, { ReactElement, useState } from 'react'

import './settings.scss'

import { useAppDispatch, useAppSelector } from '../hooks/useRedux'

import { closeModal } from '../slices/modal'
import { toggleDarkMode, setSearchLimit } from '../slices/settings'

import { ModalContainer } from './ModalContainer'

const MIN_SEARCH_LIMIT = 1
const MAX_SEARCH_LIMIT = 100

const SettingsModal = (): ReactElement | null => {
  const dispatch = useAppDispatch()

  const { darkMode, searchLimit } = useAppSelector(({ settings }) => settings)

  const [_searchLimit, _setSearchLimit] = useState(searchLimit)

  function handleDarkModeCheckBoxChange (e: React.ChangeEvent<HTMLInputElement>): void {
    dispatch(toggleDarkMode())
  }

  function handleSearchLimitInputChange (e: React.ChangeEvent<HTMLInputElement>): void {
    _setSearchLimit(e.target.value)
  }

  return (
    <ModalContainer
      title='Settings'
      width='300px'
      closeModal={() => {
        dispatch(closeModal())
        dispatch(setSearchLimit({ searchLimit: parseInt(_searchLimit, 10) }))
      }}
    >
      <div>
        <input
          type='checkbox'
          id='darkMode'
          name='darkMode'
          onChange={handleDarkModeCheckBoxChange}
          checked={darkMode}
        />
        <label htmlFor='darkMode'>Dark Mode</label>
        <label id='searchLimitLabel' htmlFor='searchLimit'>How many messages to get at a time ({MIN_SEARCH_LIMIT}-{MAX_SEARCH_LIMIT})</label>
        <input
          type='number'
          id='searchLimit'
          name='searchLimit'
          min={MIN_SEARCH_LIMIT}
          max={MAX_SEARCH_LIMIT}
          onChange={handleSearchLimitInputChange}
          value={_searchLimit}
        />
      </div>
    </ModalContainer>
  )
}

export default SettingsModal
